// extracted by mini-css-extract-plugin
export default {"searchForm":"search_searchForm__SRtn4","searchSymbol":"search_searchSymbol__-wS+m"};